import * as d3 from 'd3'
export default {
  methods: {

    draw_Image() {

      this.canvasForm
      .append('image')
      .attr('id', `BOUNDARY`)
      .attr('x', 700).attr('y', 100)
      .attr('height', 600)
      .attr('xlink:href', this.HOST + `/Visualization/SystemBoundary/${this.revision}/svg/${this.current.sys}.svg`)
      .attr('opacity', 1)
    },


  }
}
